import { Grid, Typography } from '@mui/material';
import { SimpleShowLayout, useRecordContext } from 'react-admin';
import { AddressDetails } from 'src/lib';
import { Account } from 'src/models';
import { getAccountHolderSubheader } from 'src/utils';

import { AccountHolderDetails } from './AccountHolderDetails';
import { DisclosureDetails } from './DisclosureDetails';
import { FinancialEmploymentDetails } from './FinancialEmploymentDetails';

export const AccountHolderShow = () => {
  const record = useRecordContext<Account>();

  const primarySubHeader = getAccountHolderSubheader({ isPrimary: true, type: record?.type });

  return (
    <Grid container direction='row'>
      {record.primaryAccountHolder && (
        <>
          <Grid item xs={12}>
            {primarySubHeader && (
              <SimpleShowLayout>
                <Typography variant='h5'>{primarySubHeader}</Typography>
              </SimpleShowLayout>
            )}
            <SimpleShowLayout>
              <Typography variant='h6'>Personal Information</Typography>
            </SimpleShowLayout>
            <AccountHolderDetails record={record.primaryAccountHolder} />
          </Grid>
          {record.primaryAccountHolder?.physicalAddress && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Physical Address</Typography>
              </SimpleShowLayout>
              <AddressDetails record={record.primaryAccountHolder.physicalAddress} />
            </Grid>
          )}
          {record.primaryAccountHolder?.mailingAddress && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Mailing Address</Typography>
              </SimpleShowLayout>
              <AddressDetails record={record.primaryAccountHolder.mailingAddress} />
            </Grid>
          )}
          {record.primaryAccountHolder?.financialInformation && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Financial Employment</Typography>
              </SimpleShowLayout>
              <FinancialEmploymentDetails record={record.primaryAccountHolder} />
            </Grid>
          )}
          {record.primaryAccountHolder?.disclosure && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Disclosures</Typography>
              </SimpleShowLayout>
              <DisclosureDetails record={record.primaryAccountHolder} />
            </Grid>
          )}
        </>
      )}
      {record.secondaryAccountHolder && (record.type.isJoint || record.type.isUgma || record.type.isEntity) && (
        <>
          <Grid item xs={12}>
            <SimpleShowLayout>
              <Typography variant='h5'>
                {getAccountHolderSubheader({ type: record.type, authorizedSigner: 2 })}
              </Typography>
            </SimpleShowLayout>
            <SimpleShowLayout>
              <Typography variant='h6'>Personal Information</Typography>
            </SimpleShowLayout>
            <AccountHolderDetails record={record.secondaryAccountHolder} />
          </Grid>
          {record.secondaryAccountHolder?.physicalAddress && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Physical Address</Typography>
              </SimpleShowLayout>
              <AddressDetails record={record.secondaryAccountHolder.physicalAddress} />
            </Grid>
          )}
          {record.secondaryAccountHolder?.mailingAddress && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Mailing Address</Typography>
              </SimpleShowLayout>
              <AddressDetails record={record.secondaryAccountHolder.mailingAddress} />
            </Grid>
          )}
          {record.secondaryAccountHolder?.financialInformation && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Financial Employment</Typography>
              </SimpleShowLayout>
              <FinancialEmploymentDetails record={record.secondaryAccountHolder} />
            </Grid>
          )}
          {record.secondaryAccountHolder?.disclosure && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Disclosures</Typography>
              </SimpleShowLayout>
              <DisclosureDetails record={record.secondaryAccountHolder} />
            </Grid>
          )}
        </>
      )}
      {record.otherAccountHolders?.map((holder, index) => (
        <>
          <Grid key={holder.id} item>
            <SimpleShowLayout>
              <Typography variant='h5'>
                {getAccountHolderSubheader({ type: record.type, authorizedSigner: index + 3 })}
              </Typography>
            </SimpleShowLayout>
            <SimpleShowLayout>
              <Typography variant='h6'>Personal Information</Typography>
            </SimpleShowLayout>
            <AccountHolderDetails record={holder} />
          </Grid>
          {holder.physicalAddress && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Physical Address</Typography>
              </SimpleShowLayout>
              <AddressDetails record={holder.physicalAddress} />
            </Grid>
          )}
          {holder.mailingAddress && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Mailing Address</Typography>
              </SimpleShowLayout>
              <AddressDetails record={holder.mailingAddress} />
            </Grid>
          )}
          {holder?.financialInformation && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Financial Employment</Typography>
              </SimpleShowLayout>
              <FinancialEmploymentDetails record={holder} />
            </Grid>
          )}
          {holder?.disclosure && (
            <Grid item xs={12}>
              <SimpleShowLayout>
                <Typography variant='h6'>Disclosures</Typography>
              </SimpleShowLayout>
              <DisclosureDetails record={holder} />
            </Grid>
          )}
        </>
      ))}
    </Grid>
  );
};
